<template>
  <transition name="fade">
      <div class="help-menu-active">
        <div v-click-outside="toggleHelpMenu" class="menu-holder">
          <rp-sprite name="more_vert" @click.native="toggleHelpMenu"></rp-sprite>
          <div class="menu-content-info">
            <div class="version">RayPRO Version: {{appVersion}}</div>
          </div>        

          <div class="menu-content-with-icons">
            <a href="mailto:raypro@rayner.com" class="item">
              <rp-sprite class="input-icon" name="email"/>
              <div class="content-text">RayPRO Support</div>
            </a>

            <div class="item" @click="showOnboarding">
              <rp-sprite class="input-icon" name="school"/>
              <div class="content-text">Onboarding</div>
            </div>
            
          </div>   

          <rp-permissions :requireAll="['presenter_view']">
            <div class="menu-content-with-icons no-border">
              <router-link :to="'/presenter-view'" class="item">
                <rp-sprite class="input-icon" name="fullscreen"/>
                <div class="content-text">Presenter Mode</div>
              </router-link>
            </div>
          </rp-permissions>

        </div>
      </div>
    </transition>
</template>

<script>
import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import appVersion from 'raw-loader!../../version.txt'
import Permissions from 'raypro_ui/src/components/Permissions'

import store from '@/store/'
import * as onboarding from 'raypro_ui/src/store/modules/onboarding/types'
import {mapGetters} from 'vuex'

import ClickOutside from 'raypro_ui/src/directives/clickOutside'

export default {
  components: {
    'rp-sprite': RpSprite,
    'rp-permissions': Permissions
  },

  data() {
    return {appVersion}
  },

  computed: {...mapGetters(['authUser', 'isOnboarded'])},

  methods: {
    showOnboarding() {
      const filtered = this.isOnboarded.filter((item) => {
        return item !== this.authUser.id
      })

      store.commit(onboarding.IS_ONBOARDED, filtered)
      this.$emit('toggleHelpMenu')
    },

    toggleHelpMenu() {
      this.$emit('toggleHelpMenu')
    }
  },

  directives: {ClickOutside}

}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
  @import '../stylesheets/helpers/mixins'

  .help-menu-active
    position: absolute
    z-index: 9999

    .menu-holder
      width: 260px
      height: 100%
      background: #2A4964
      -webkit-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2)
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2)
      margin: 5px 0 0 5px
      padding-bottom: 30px

      .sprite
        cursor: pointer
        width: 20px
        height: 20px
        margin: 9px 4px
        fill: black

      .menu-content-info
        width: 200px
        padding-top: 9px
        margin-left: 27px
        margin-bottom: 5px
        text-size: 16px
        border-bottom: 1px solid $color-border-lighter

        .version
          margin-bottom: 20px

      .menu-content-with-icons
        width: 200px
        margin-left: 27px
        padding-bottom: 5px
        text-size: 16px
        margin-top: 15px
        border-bottom: 1px solid $color-border-lighter
        display: flex
        flex-direction: column
        justify-content: center

        &.no-border
          border-bottom: none
          margin-bottom: 0

        a.router-link-active
          background-color: unset
        
        
        .item
          display: flex
          flex-direction: row
          padding: 5px 0 5px 0px
          cursor: pointer 

        .sprite
          position: relative
          margin-top: -100px
          width: 20px
          height: 20px
          margin: 0 3px
          top: -5px
          left: -2px
          fill: $color-text-dark
</style>



// WEBPACK FOOTER //
// src/components/HelpMenu.vue